import { render } from "./AppNavSettings.vue?vue&type=template&id=4d08b347&scoped=true&ts=true"
import script from "./AppNavSettings.vue?vue&type=script&lang=ts"
export * from "./AppNavSettings.vue?vue&type=script&lang=ts"

import "./AppNavSettings.vue?vue&type=style&index=0&id=4d08b347&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d08b347"]])

export default __exports__